/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateProjectRequestBody = {
  /**
   * The name of the project
   */
  name: string;
  /**
   * The ID of the organization to create the project in
   */
  organizationId: string;
};

/** @internal */
export type CreateProjectRequestBody$Outbound = {
  name: string;
  organization_id: string;
};

/** @internal */
export const CreateProjectRequestBody$outboundSchema: z.ZodMiniType<
  CreateProjectRequestBody$Outbound,
  CreateProjectRequestBody
> = z.pipe(
  z.object({
    name: z.string(),
    organizationId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
    });
  }),
);

export function createProjectRequestBodyToJSON(
  createProjectRequestBody: CreateProjectRequestBody,
): string {
  return JSON.stringify(
    CreateProjectRequestBody$outboundSchema.parse(createProjectRequestBody),
  );
}
